<template>
  <Breadcrumbs
      title="Create Order Request"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Order Request History', path: '/order-request-history' },
      { label: 'Create Order Request', path: '/order-create' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <orderForm/>
    </div>
  </div>
</template>

<script>

import orderForm from './orderRequestForm.vue'
export default {
  name: 'indexList',
  components: {

    orderForm,

  },


}

</script>
